export default "__VITE_ASSET__CzXgHzjU__"